<ion-app [ngStyle]="ionAppStyle">
  <div class="ion-page">
    @if (isIframe) {
      <ion-router-outlet></ion-router-outlet>
    }
    @if (!isIframe) {
      <span class="auth-as">
        @if (largeScreen && ready) {
          <ion-split-pane contentId="main">
            <ion-menu type="overlay" contentId="main">
              <ion-header [translucent]="true" color="light">
                <ion-toolbar>
                  <ion-title>{{ 'APP_NAVIGATION.MENU' | translate }}</ion-title>
                </ion-toolbar>
              </ion-header>
              <ion-content color="light">
                <ion-list class="ion-no-padding">
                  <ion-menu-toggle auto-hide="false">
                    <ion-item
                      routerDirection="root"
                      routerLink="stations"
                      routerLinkActive="tab-selected"
                      [state]="{ hideSearch: true }">
                      <ion-icon slot="start" name="home" class="selected"></ion-icon>
                      <ion-icon slot="start" name="home-outline" class="unselected"></ion-icon>
                      <ion-label>
                        {{ 'APP_NAVIGATION.HOME' | translate }}
                      </ion-label>
                    </ion-item>
                  </ion-menu-toggle>
                  <ion-menu-toggle auto-hide="false">
                    <ion-item routerDirection="root" routerLink="map">
                      <ion-icon slot="start" name="map" class="selected"></ion-icon>
                      <ion-icon slot="start" name="map-outline" class="unselected"></ion-icon>
                      <ion-label>{{ 'APP_NAVIGATION.MAP' | translate }}</ion-label>
                    </ion-item>
                  </ion-menu-toggle>
                  <ion-menu-toggle auto-hide="false">
                    <ion-item routerDirection="root" routerLink="orders">
                      <ion-icon slot="start" name="basket" class="selected"></ion-icon>
                      <ion-icon slot="start" name="basket-outline" class="unselected"></ion-icon>
                      <ion-label>
                        {{ 'APP_NAVIGATION.HISTORY' | translate }}
                      </ion-label>
                    </ion-item>
                  </ion-menu-toggle>
                  <ion-menu-toggle *canSee="[UserType.Installer, UserType.Operator]" auto-hide="false">
                    <ion-item routerDirection="root" routerLink="installer">
                      <ion-icon slot="start" name="construct" class="selected"></ion-icon>
                      <ion-icon slot="start" name="construct-outline" class="unselected"></ion-icon>
                      <ion-label>
                        {{ 'APP_NAVIGATION.INSTALLER' | translate }}
                      </ion-label>
                    </ion-item>
                  </ion-menu-toggle>
                  @if (loggedIn$ | async) {
                    <ion-menu-toggle auto-hide="false">
                      <ion-item routerDirection="root" routerLink="settings">
                        <ion-icon slot="start" name="settings" class="selected"></ion-icon>
                        <ion-icon slot="start" name="settings-outline" class="unselected"></ion-icon>
                        <ion-label>
                          {{ 'APP_NAVIGATION.SETTINGS' | translate }}
                        </ion-label>
                      </ion-item>
                    </ion-menu-toggle>
                  }
                  @if ((loggedIn$ | async) === false) {
                    <ion-menu-toggle auto-hide="false">
                      <ion-item routerDirection="root" routerLink="login">
                        <ion-icon slot="start" name="lock-closed" class="selected"></ion-icon>
                        <ion-icon slot="start" name="lock-closed-outline" class="unselected"></ion-icon>
                        <ion-label>
                          {{ 'APP_NAVIGATION.LOGIN' | translate }}
                        </ion-label>
                      </ion-item>
                    </ion-menu-toggle>
                  }
                </ion-list>
              </ion-content>
              <ion-footer class="menu-footer">
                @if (loggedInAs) {
                  <div class="authAs">
                    <h4>Logged in as: {{ loggedInAs.Email }}</h4>
                    <ion-button color="danger" (click)="logoutAs()"> Logout </ion-button>
                  </div>
                }
                <img src="assets/img/brand/normal_logo.png" alt="{{ appConfig.title }}" />
                @if (appConfig.showTitle) {
                  <h4>{{ appConfig.title }}</h4>
                }
                <p (tap)="showLog()" class="version"> {{ 'APP_NAVIGATION.VERSION' | translate }} {{ version }} </p>
              </ion-footer>
            </ion-menu>
            <ion-router-outlet id="main"></ion-router-outlet>
          </ion-split-pane>
        }
        @if (!largeScreen && ready) {
          <span>
            @if (loggedInAs) {
              <ion-fab class="authAsFab" vertical="bottom" horizontal="middle" slot="fixed">
                <ion-fab-button (click)="openAuthAs()">
                  <ion-icon name="person"></ion-icon>
                </ion-fab-button>
              </ion-fab>
            }
            <ion-tabs>
              @if (showMigration) {
                <sc-migration></sc-migration>
              }
              @if (!hideAppBar) {
                <ion-tab-bar slot="bottom">
                  <ion-tab-button tab="stations" (click)="openStations()">
                    <ion-icon name="home" class="selected"></ion-icon>
                    <ion-icon name="home-outline" class="unselected"></ion-icon>
                    <ion-label>{{ 'APP_NAVIGATION.HOME' | translate }}</ion-label>
                  </ion-tab-button>
                  <ion-tab-button tab="map">
                    <ion-icon name="map" class="selected"></ion-icon>
                    <ion-icon name="map-outline" class="unselected"></ion-icon>
                    <ion-label>{{ 'APP_NAVIGATION.MAP' | translate }}</ion-label>
                  </ion-tab-button>
                  <ion-tab-button tab="orders">
                    <ion-icon name="basket" class="selected"></ion-icon>
                    <ion-icon name="basket-outline" class="unselected"></ion-icon>
                    <ion-label>{{ 'APP_NAVIGATION.HISTORY' | translate }}</ion-label>
                  </ion-tab-button>
                  <ion-tab-button *canSee="[UserType.Installer, UserType.Operator]" tab="installer">
                    <ion-icon name="construct" class="selected"></ion-icon>
                    <ion-icon name="construct-outline" class="unselected"></ion-icon>
                    <ion-label>
                      {{ 'APP_NAVIGATION.INSTALLER' | translate }}
                    </ion-label>
                  </ion-tab-button>
                  @if (loggedIn$ | async) {
                    <ion-tab-button tab="settings">
                      <ion-icon name="settings" class="selected"></ion-icon>
                      <ion-icon name="settings-outline" class="unselected"></ion-icon>
                      <ion-label>{{ 'APP_NAVIGATION.SETTINGS' | translate }}</ion-label>
                    </ion-tab-button>
                  }
                  @if ((loggedIn$ | async) === false) {
                    <ion-tab-button tab="login">
                      <ion-icon name="lock-closed" class="selected"></ion-icon>
                      <ion-icon name="lock-closed-outline" class="unselected"></ion-icon>
                      <ion-label>{{ 'APP_NAVIGATION.LOGIN' | translate }}</ion-label>
                    </ion-tab-button>
                  }
                </ion-tab-bar>
              }
            </ion-tabs>
          </span>
        }
      </span>
      @if (largeScreen && ready && showMigration) {
        <sc-migration></sc-migration>
      }
    }
  </div>
</ion-app>
